/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-no-bind */
import Helper from "../../shared/modules/Helper";
import PropTypes from "prop-types";
import React from "react";

const SearchResultsBanner = ({searchParam}) => {

  const clearSearchUrl = () => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    params.delete("search");
    const paramsString = Helper.addSearchParamToUrl(params);
    window.location.href = `${url.pathname}?${paramsString}`;
  };

  const handleStartNewSearch = () => {
    const element = document.getElementById("search-container");
    if (element) {
      element.setAttribute("data-focused", "true");
    }
  };

  return (
    <div
      className="flex flex-col items-center justify-center pt-8 pb-4"
    >
      <div
        className="font-serif font-normal text-[20px]"
      >
        Search Results
      </div>
      <div
        className="font-sans font-normal text-[18px]"
      >
        for
        "
        {searchParam}
        "
      </div>
      <div
        className="flex gap-2"
      >
        <div
          className="font-sans font-normal text-[18px] underline cursor-pointer"
          id="start-new-search"
          onClick={handleStartNewSearch}
        >
          Start another search
        </div>
        <div
          className="font-sans font-normal text-[18px] underline cursor-pointer"
          id="clear-search"
          onClick={clearSearchUrl}
        >
          Clear search results
        </div>
      </div>
    </div>
  );
};

SearchResultsBanner.propTypes = {"searchParam": PropTypes.string.isRequired};

export default SearchResultsBanner;
